/* © Facilogi. See COPYRIGHT file for full copyright & licensing details. */

import { PriceAudit } from "App/IOC/Services";

export default {
    FindByPrice: PriceAudit.FindByPrice,
    FindByPlan: PriceAudit.FindByPlan
};
